import { Typography } from "@mui/material";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";
import { StudioData } from "../../Objects/StudioInterface";

interface StudioNameProps {
    studioData: StudioData,
    showId?: boolean
}

const StudioName: React.FC<StudioNameProps> = ({
    studioData,
    showId
}) => {
    return (
        <>
            <Typography
                variant="h6"
            >
                {showId && `[${studioData.std_id}]`}
                {studioData.std_name}
                {studioData.std_area && " / " + studioData.std_area}
            </Typography>
        </>
    );
}

export default StudioName